export default __webpack_public_path__ + "static/Square-4d7912c217c494ad638919cb08e1eabc.svg";